import { render, staticRenderFns } from "./StatisticsMenuView.vue?vue&type=template&id=79f1c114"
import script from "./StatisticsMenuView.vue?vue&type=script&lang=js"
export * from "./StatisticsMenuView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports